module.exports = __webpack_public_path__ + "img/2942128.0242b509.svg";